import React from 'react';
import {useForm} from "@inertiajs/inertia-react";
import {useDispatch} from "react-redux";
import {closeModal} from "@/Store/Slices/ModalSlice";

const PublicMerchant = ({id}) => {
  const {put} = useForm({ id: id });
  const dispatch = useDispatch();
  const handlePublished = () => {
    put(route('added.merchants.public', id).url());
    dispatch(closeModal());
  }

  return (
    <>
      <div className="modal-body">
        Do you want this merchant to show online?
      </div>
      <div className="modal-footer flex justify-end">
        <button onClick={handlePublished} className="btn-default bg-green-700 focus:outline-none py-2 px-4">
          <span>Yes</span>
        </button>
      </div>
    </>
  );
};

export default PublicMerchant;
